/** Shared search surfaces — align with globals.css tokens */
export const SEARCH = {
  primary: "#1f7a4d",
  primaryDark: "#123524",
  surface: "#fafdfb",
  surfaceElevated: "#ffffff",
  border: "rgba(31, 122, 77, 0.14)",
  borderStrong: "rgba(31, 122, 77, 0.22)",
  text: "#102117",
  muted: "#5e6d63",
  mutedLight: "rgba(16, 33, 23, 0.55)",
  accentGold: "#c9a227",
  radiusLg: "20px",
  radiusMd: "14px",
  radiusSm: "10px",
  shadowCard: "0 4px 20px rgba(16, 33, 23, 0.07)",
  shadowCardHover: "0 12px 36px rgba(16, 33, 23, 0.1)",
  fontDisplay: "var(--salontym-font-display), Georgia, serif",
  fontBody: "var(--salontym-font-body), system-ui, sans-serif",
} as const;
